import findAllFor from '../filters/find-all-for';

const getMoveConstraintForElement = (element) => {
  const constraints = findAllFor(element);

  return constraints.find((constraint) => constraint.movable);
};

export default getMoveConstraintForElement;
